import React from "react";
import ReactDOM from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { usePromiseTracker } from "react-promise-tracker";
import LoadingIndicator from "components/layout/loadingIndicator/LoadingIndicator";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <BrowserRouter>
    <Handlers />
  </BrowserRouter>
);

function Handlers() {
  const { promiseInProgress } = usePromiseTracker();

  return (
    <>
      <ToastContainer
        position="bottom-right"
        // autoClose="5000"
        hideProgressBar={true}
      />
      {promiseInProgress && <LoadingIndicator />}
      <App />
    </>
  );
}
